import { StaticPage } from '@dreamstack/accentro-contentful/src/components/StaticPage'
import { getStaticPagePaths } from '@dreamstack/accentro-contentful/src/contentful/staticPages/getStaticPagePaths'
import { getStaticPageProps } from '@dreamstack/accentro-contentful/src/contentful/staticPages/getStaticPageProps'
import { useParams } from '@dreamstack/feature-components/src/hooks/useParams'
import { getStaticPathsPlus } from '../lib/next/getStaticPathsPlus'
import { getStaticPropsPlus } from '../lib/next/getStaticPropsPlus'

export default function StaticPagePage() {
  const { slug } = useParams()
  return <StaticPage slug={slug} />
}

export const getStaticProps = getStaticPropsPlus({
  getProps: getStaticPageProps,
})

export const getStaticPaths = getStaticPathsPlus(
  getStaticPagePaths({ slugsNotToBuild: ['index', 'news', '404'] })
)
